import { Skeleton, Stack } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/ui'

import { BookingDatesLoading, LayoutBookingOverview, LayoutBookingOverviewContent } from '../common'

export const BookingOverviewCompactLoading: FC = () => {
  return (
    <LayoutBookingOverview>
      <Stack paddingBottom={unit(5)} paddingTop={unit(2)} justifyItems='center' alignItems='center'>
        <Skeleton width='50%' height={unit(13)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
      </Stack>
      <LayoutBookingOverviewContent>
        <BookingDatesLoading />
        <Stack
          height={unit(13)}
          sx={{ border: `${unit(0.5)} solid ${COLORS.white}` }}
          alignItems='center'
          justifyContent='center'
        >
          <Skeleton width='30%' height={unit(5)} sx={{ bgcolor: COLORS.white }} variant='rectangular' />
        </Stack>
      </LayoutBookingOverviewContent>
    </LayoutBookingOverview>
  )
}
